import { connect } from "react-redux";
import {
  fieldsSelector,
  updateField,
  updateTotalsRowField,
} from "../../../redux/settings";
import { close } from "../../../redux/modals/settingsModal";
import SettingsModal from "./SettingsModal";

const mapStateToProps = (state) => ({
  fields: fieldsSelector(state) || {},
  totalsRowFields: state.settings.totalsRowFields || {},
  show: state.modals.settingsModal.show,
  itemTypes: state.settings.itemTypes || [],
});

const mapDispatchToProps = {
  onHide: close,
  onUpdateField: updateField,
  onUpdateTotalsRowField: updateTotalsRowField,
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModal);
